<template>
  <div class="modal" v-if="seen">
    <template v-if="account_type == 2">
      <div class="deletefile browse_folder">
        <span @click="closebox" class="closefile">
          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path
              fill="#f9f9f9"
              d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
            />
          </svg>
        </span>
        <div class="header">
          <h3>
            <span> Edit Share ({{ folder_name }}) Right </span>
          </h3>
        </div>
        <div class="finduser sharefile-find-user">
          <input
            type="text"
            placeholder="Find a user..."
            @input="search_user"
          />
        </div>
        <div class="cgn browsefolder">
          <ul class="selected_folders">
            <li
              v-for="(name, index) in users"
              :key="index"
              :ref="'l_' + index"
              class="s-user"
            >
              <div class="user">
                <div class="user-data">
                  <span class="img">
                    <template v-if="name.photo">
                      <span class="profile-pic">
                        <img :src="getPhoto(name.photo)" />
                      </span>
                    </template>
                    <template v-else>
                      <span class="profile-initials">{{
                        getInitials(name.names)
                      }}</span>
                    </template>
                  </span>
                  <span class="dir">
                    <strong>{{ name.names }}</strong
                    ><br />
                    <span>Department: {{ name.department }}</span>
                  </span>
                </div>
                <span
                  :class="[
                    isSelected(name._id) ? 'selected-close' : 'hidden-close',
                  ]"
                  @click="removeFileAccess(name._id)"
                >
                  <svg style="width: 16px; height: 16px" viewBox="0 0 24 24">
                    <path
                      fill="#000000"
                      d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
                    />
                  </svg>
                </span>
              </div>
              <div class="rights">
                <label @change="folder_right(name._id, 'can_edit', index)">
                  <input type="checkbox" v-model="name.edit" />
                  &nbsp;Edit
                </label>
                <label @change="folder_right(name._id, 'can_download', index)">
                  <input type="checkbox" v-model="name.download" />
                  &nbsp;Download
                </label>
                <label @change="folder_right(name._id, 'can_print', index)">
                  <input type="checkbox" v-model="name.print" />
                  &nbsp;Print
                </label>
                <label @change="folder_right(name._id, 'can_delete', index)">
                  <input type="checkbox" v-model="name.delete" />
                  &nbsp;Delete
                </label>
              </div>
            </li>
          </ul>
        </div>
        <div class="save">
          <div class="save-btn">
            <span @click="sharefile" class="savebtn">
              <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                <path
                  fill="#fff"
                  d="M19,21V19H15V17H19V15L22,18L19,21M10,4A4,4 0 0,1 14,8A4,4 0 0,1 10,12A4,4 0 0,1 6,8A4,4 0 0,1 10,4M10,14C11.15,14 12.25,14.12 13.24,14.34C12.46,15.35 12,16.62 12,18C12,18.7 12.12,19.37 12.34,20H2V18C2,15.79 5.58,14 10,14Z"
                />
              </svg>
              Continue
            </span>
          </div>
          <div v-if="error" class="error" style="margin-top: 0; margin-left: 0">
            Please select a user
          </div>
        </div>
      </div>
    </template>
    <template v-if="account_type == 1">
      <div class="deletefile browse_folder single-user">
        <span @click="closebox" class="closefile">
          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path
              fill="#111"
              d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
            />
          </svg>
        </span>
        <div class="header">
          <h3>
            <span> Share with others </span>
          </h3>
        </div>
        <div class="file-title">
          <span>
            <strong>{{ str_text(folder_name) }}</strong>
          </span>
        </div>
        <div class="finduser">
          <p>People(enter emails of persons you want to share file with)</p>
          <div class="email">
            <span
              class="email-text"
              v-for="(person, index) in people"
              :key="index"
              >{{ person }}
              <cite
                class="remove fa fa-times"
                @click="removeperson(index)"
              ></cite
            ></span>
            <input
              type="text"
              placeholder="email address"
              v-model="person_email"
              @keyup="email_input"
            />
          </div>
          <p v-if="email_valid" class="err">Please enter a valid email</p>
          <div
            class="sharetype"
            style="
              margin-left: 0;
              margin-top: 0.6em;
              width: 100%;
              font-size: 12px;
            "
          >
            <span @click="select_share_type('email')">
              <svg
                style="width: 24px; height: 24px"
                viewBox="0 0 24 24"
                v-if="!share_type.email"
              >
                <path
                  fill="#000000"
                  d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                />
              </svg>
              <svg
                style="width: 24px; height: 24px"
                viewBox="0 0 24 24"
                v-if="share_type.email"
              >
                <path
                  fill="#2e7d32"
                  d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
                />
              </svg>
              &nbsp;Send file via email
            </span>
            <span class="type_link" @click="select_share_type('link')">
              <span class="link">
                <svg
                  style="width: 24px; height: 24px"
                  viewBox="0 0 24 24"
                  v-if="!share_type.link"
                >
                  <path
                    fill="#000000"
                    d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                  />
                </svg>
                <svg
                  style="width: 24px; height: 24px"
                  viewBox="0 0 24 24"
                  v-if="share_type.link"
                >
                  <path
                    fill="#2e7d32"
                    d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
                  />
                </svg>
                &nbsp;Share link to file via email
              </span>
              <!--<span class="file-right">
                                <span><strong>File access right</strong></span>
                                <span>
                                    <span>View File</span>
                                    <span>Edit File</span>
                                </span>
                            </span>-->
            </span>
          </div>
        </div>
        <div class="save">
          <div class="save-btn" style="margin-top: 0">
            <span @click="sharefileemail" class="savebtn">
              Send &nbsp;
              <svg style="width: 14px; height: 14px" viewBox="0 0 24 24">
                <path fill="#fff" d="M2,21L23,12L2,3V10L17,12L2,14V21Z" />
              </svg>
            </span>
          </div>
          <div
            v-if="email_error"
            class="error"
            style="margin-top: 0; margin-left: 0"
          >
            Please enter an email
          </div>
        </div>
      </div>
    </template>
    <loading ref="loading"></loading>
    <notify ref="notify"></notify>
  </div>
</template>
<style scoped>
.sharefile-find-user input {
  width: 100%;
  border: 1px #f1f1f1 solid;
  border-radius: 2px;
  padding: 0.6em 0.8em;
}
.save .save-btn .savebtn {
  background: #3f96d1 !important;
  font-size: 12px !important;
  height: 36px !important;
  padding: 0 1em !important;
  margin-top: 1em;
}
.save-btn {
  display: flex;
  flex-direction: row !important;
  margin-left: 0 !important;
  width: 100% !important;
}
.save-btn span {
  background: none !important;
}
.save .save-btn .share-options span {
  color: #333 !important;
  font-size: 14px !important;
}
.save .save-btn .share-options span:hover {
  text-decoration: underline;
}
.single-user .header h3 {
  display: flex;
  justify-content: space-between;
}
.single-user .finduser {
  margin-top: 2em;
  margin-bottom: 2em;
}
.single-user .finduser p:first-child {
  font-size: 14px;
}
.single-user .finduser p:last-child {
  padding: 0.9em;
  border: 1px solid #999;
}
.selected-user {
  margin-top: 0.6em;
}
.remove {
  cursor: pointer;
}
.file-title {
  margin-top: 0.5em;
}
.sharetype {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.6em;
}
.sharetype span:last-child {
  margin-left: 0.8em;
}
.sharetype span {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.type_link {
  display: flex;
  flex-direction: column !important;
}
.selected-user .selected {
  background: #f1f1f1;
  border: 1px solid #ccc;
  font-size: 12px;
  font-weight: 600;
  padding: 0.2em 0.6em;
  margin-right: 0.3em;
  display: inline-block;
  border-radius: 50px;
}
.finduser {
  margin-top: 0.5em !important;
  margin-bottom: 0.5em !important;
  width: 87% !important;
}
.finduser > p {
  font-size: 14px;
  margin-bottom: 0.5em !important;
}
.finduser .email input {
  border: none;
  padding: 5px 3px;
  outline: 0;
  width: 100%;
}
.finduser .err {
  color: #fc6d6c;
  border: none !important;
  padding: 0 !important;
}
.save {
  flex-direction: column !important;
  margin-top: 0 !important;
}
.finduser .email-text {
  background: rgb(223, 220, 220);
  color: #333;
  display: inline-flex;
  justify-content: center;
  font-size: 14px;
  align-items: center;
  padding: 2px 8px;
  border-radius: 3px;
  margin-right: 0.5em;
}
.finduser .email-text .fa {
  display: inline-block;
  margin-left: 0.5em;
  font-size: 12px;
  color: #fc6d6c;
}
.finduser .email {
  border: 1px solid rgb(230, 230, 230);
  padding: 3px 3px;
  margin: 0;
  outline: 0;
  display: flex;
  margin-top: 0.4em !important;
  width: 100%;
}
.selected_folders li {
  display: block;
  border-bottom: 1px solid #f1f1f1;
}
.selected_folders li:last-child {
  display: block;
  border-bottom: none;
}
.selected_folders li:hover {
  background: none;
}
.selected_folders li .user {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  width: 100%;
}
.selected_folders li .user .img {
  height: 48px;
  width: 48px;
}
.selected_folders li .user .dir {
  margin-left: 0.7em;
}
.selected_folders li .user .add-user {
  cursor: pointer;
  height: 38px;
  display: flex;
  background-color: #3dbb1e;
  border-radius: 3px;
  border: none;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  align-items: center;
  justify-content: center;
  width: 80px;
}
.selected_folders li .user div {
  display: flex;
  align-items: center;
  margin: 0;
}
.selected_folders li .rights {
  display: flex;
  align-items: center;
  margin: 0;
  margin-top: 0.5em !important;
  width: 100%;
}
.selected_folders li .rights label {
  display: flex;
  align-items: center;
  margin-right: 0.9em;
}
.modal {
  display: flex;
}
.cgn {
  display: flex;
  flex-direction: column;
}
.cgn span {
  margin-bottom: 0.4em;
}

.profile-initials {
  background-color: rgba(226, 232, 240, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  border-radius: 100%;
  font-size: 1.125rem;
  color: rgba(113, 128, 150, 1);
}

.selected-close {
  display: none;
}

.hidden-close {
  display: none;
}

.user:hover .selected-close {
  display: block;
}

.user-data {
  cursor: default;
}

.s-user:hover {
  background-color: rgb(240, 240, 240) !important;
}

.s-user:hover .profile-initials {
  background-color: #fff !important;
}

/* new styles */
</style>

<script>
import loading from "@/components/Loading";
import notify from "@/components/Notify";
import cookies from "@/services/cookies";
import { mapState } from "vuex";
export default {
  components: {
    loading,
    notify,
  },
  data() {
    return {
      names: [],
      seen: false,
      loader: false,
      error: false,
      found: false,
      file_id: null,
      share_id: null,
      folder_name: "",
      selected_users: [],
      stored_users: [],
      folder_users: [],
      account_type: 1,
      can_edit: [],
      can_delete: [],
      can_print: [],
      can_download: [],
      removeuser: [],
      person_email: "",
      people: [],
      email_valid: false,
      email_error: false,
      str: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      share_type: {
        email: true,
        link: false,
      },
      type: "email",
      via_email: false,
      via_link: false,
    };
  },
  computed: {
    ...mapState(["backendUrl"]),
    users: function () {
      let that = this;
      return this.names.filter(function (name) {
        return !name.is_selected;
      });
    },
  },
  methods: {
    isSelected(id) {
      return this.selected_users.find((user) => user._id == id);
    },
    getPhoto(photo) {
      const pt = `${this.backendUrl}/static-photos/${photo}`;
      return pt;
    },
    getInitials(name) {
      const nm = name;
      return nm.charAt(0);
    },
    logincall() {
      this.$parent.logincall();
    },
    removeperson(index) {
      this.people.splice(index, 1);
    },
    notify(text) {
      this.$parent.notify(text);
    },
    str_text(str) {
      return str.length > 40 ? str.substr(0, 40) + "..." : str;
    },
    remove_user(id) {
      let index_of = this.folder_users.indexOf(id);
      this.folder_users = this.folder_users.filter((_id) => _id != id);
      this.selected_users = this.selected_users.filter(
        (user) => user._id != id
      );
    },
    search_user(evt) {
      if (evt.target.value) {
        let data = JSON.parse(JSON.stringify(this.stored_users));
        this.names = data.filter(function (user) {
          return user.names
            .toLowerCase()
            .includes(evt.target.value.toLowerCase());
        });
      } else {
        this.names = this.stored_users;
      }
    },
    select_user(index, right) {
      this.error = false;
      const user = this.names[index];
      const isFound = this.folder_users.indexOf(user._id);
      if (isFound === -1) {
        this.selected_users.push(user);
        this.folder_users.push(user._id);
        this.names.map((name) => {
          if (name._id === user._id) {
            if (right === "can_edit") {
              name.edit = true;
            } else if (right === "can_download") {
              name.download = true;
            } else if (right === "can_delete") {
              name.delete = true;
            } else if (right === "can_print") {
              name.print = true;
            }
          }
          return name;
        });
      }
    },
    folder_right(id, right, index) {
      if (right === "can_edit") {
        let eIndex = this.can_edit.indexOf(id);
        if (eIndex !== -1) {
          this.can_edit.splice(eIndex, 1);
          this.remove_user(id);
        } else {
          this.can_edit.push(String(id));
          this.select_user(index, right);
        }
      }

      if (right === "can_download") {
        let dIndex = this.can_download.indexOf(id);
        if (dIndex !== -1) {
          this.can_download.splice(dIndex, 1);
          this.remove_user(id);
        } else {
          this.can_download.push(String(id));
          this.select_user(index, right);
        }
      }

      if (right === "can_print") {
        let pIndex = this.can_print.indexOf(id);
        if (pIndex !== -1) {
          this.can_print.splice(pIndex, 1);
          this.remove_user(id);
        } else {
          this.can_print.push(String(id));
          this.select_user(index, right);
        }
      }

      if (right === "can_delete") {
        let dtIndex = this.can_delete.indexOf(id);
        if (dtIndex !== -1) {
          this.can_delete.splice(dtIndex, 1);
          this.remove_user(id);
        } else {
          this.can_delete.push(String(id));
          this.select_user(index, right);
        }
      }
    },
    removeFileAccess(id) {
      this.removeuser.push(String(id));
      this.names = this.names.filter((user) => user._id != id);
      this.folder_users = this.folder_users.filter((_id) => _id != id);
      this.selected_users = this.selected_users.filter(
        (user) => user._id != id
      );
    },
    sharefile() {
      if (this.selected_users.length) {
        this.$refs.loading.load();
        let data = {
          id: this.share_id,
          users: this.folder_users,
          token: cookies.getCookie("token"),
          file_id: this.file_id,
          edit: this.can_edit,
          delete: this.can_delete,
          download: this.can_download,
          print: this.can_print,
          remove_user: this.removeuser,
        };

        let that = this;
        this.$socket.emit("edit-share-user-file", data, function (data) {
          if (data.data === true) {
            that.$refs.loading.close();
            that.seen = false;
            that.folder_users = [];
            that.can_edit = [];
            that.can_delete = [];
            that.can_print = [];
            that.can_download = [];
            that.removeuser = [];
            // that.notify('File shared successfully...')
            that.$toast.open({
              message:
                '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg> File shared successfully...',
              type: "default",
              position: "bottom-right",
            });
          }

          if (data.data === false) {
            that.done = false;
            that.loader = false;
            that.seen = false;
            that.folder_users = [];
            that.can_edit = [];
            that.can_delete = [];
            that.can_print = [];
            that.can_download = [];
            that.removeuser = [];
            that.logincall();
            that.$router.push('/login')
          }
        });
      } else {
        this.error = true;
      }
    },
    load(data, index) {
      let that = this;
      this.seen = true;
      this.names = [];
      this.selected_users = [];
      (this.folder_name = this.$store.getters.DIRECTORY_CHILDREN[index].dir),
        (this.account_type =
          this.$store.getters.ISSTAFF == true ||
          this.$store.getters.ISSUPERADMIN == true
            ? 2
            : 1);
      this.share_id = data.id;

      if (this.account_type == 2) {
        this.$socket.emit("get-shared-file-users", data, function (data) {
          if (data.data === true) {
            that.names = data.users;
            that.file_id = data.file_id;
            that.stored_users = data.users;

            for (let i = 0; i < data.users.length; i++) {
              if (data.users[i].edit) {
                that.can_edit.push(data.users[i]._id);
              }

              if (data.users[i].delete) {
                that.can_delete.push(data.users[i]._id);
              }

              if (data.users[i].print) {
                that.can_print.push(data.users[i]._id);
              }

              if (data.users[i].download) {
                that.can_download.push(data.users[i]._id);
              }
            }
          }

          if (data.data === false) {
            that.seen = false;
            that.logincall();
            that.$router.push('/login')
          }
        });
      }
    },
    closebox() {
      this.selected_users = [];
      this.names = [];
      this.can_edit = [];
      this.can_delete = [];
      this.can_print = [];
      this.can_download = [];
      this.removeuser = [];
      this.seen = false;
    },
  },
};
</script>
